import { Reducer } from 'redux';

import { changeUser } from '#/reduxState/currentUser/currentUserReducer';

/** Inform UI about signing out process which can take couple seconds */
export function userSigningOut() {
  return {
    type: 'USER_SIGNING_OUT',
  } as const;
}

type UserProcessesAction = ReturnType<
  typeof userSigningOut | typeof changeUser
>;

type UserProcesses = {
  signingOut: boolean;
};

export const userProcessesReducer: Reducer<
  UserProcesses,
  UserProcessesAction
> = (
  state = {
    signingOut: false,
  },
  action
) => {
  switch (action.type) {
    case 'USER_SIGNING_OUT': {
      return { signingOut: true };
    }
    case 'CHANGE_USER': {
      return { signingOut: false };
    }
    default:
      return state;
  }
};
